import React, { useEffect, useState } from "react";

import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import {
  logOut,
  setInValidUser,
} from "../../../redux/actions/authActions/authAction";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import LoaderButton from "../../Common/LoaderButton";
import * as constantMessages from "../../../constants/constatntMessages";
import { handleApiError } from "../../../helpers/errorResponseHelper";
import BackButton from "../../Common/Backbutton";
import SmallLoaderButton from "../../Common/SmallLoaderButton";
 const DraftCleanupDays = parseInt(process.env.DRAFT_CLEANUP_DAY, 10) || 10;


const generateOptions = (max, step = 1) => {
  if (step <= 0) {
    step = 1;
  }
  return Array.from({ length: Math.floor(max / step) + 1 }, (_, i) => i * step);
};

const generateOptionNew = (max, step = 1) => {
  if (step < 1) {
    step = 1;
  }
  return Array.from(
    { length: Math.floor(max / step) },
    (_, i) => (i + 1) * step
  );
};

const Configuration = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const employeeData = useSelector((state) => state.user);
  useEffect(() => {
    if (employeeData?.userData) {
      if (employeeData.userData.isAdmin === false) {
        navigate("/page-not-found");
      }
    }
  }, [employeeData?.userData]);
  const organizationId = userData?.organizationId;
  const accessToken = localStorage.getItem("accessToken");

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [draftMeetingCleanupDays, setdraftMeetingCleanupDays] = useState(0);
  const [draftMeetingReminderDays, setdraftMeetingReminderDays] = useState(0);
  const [config, setConfig] = useState({
    amendmentRequestTime: 1,
    acceptanceRejectionEndtime: 1,
    writeMinuteMaxTimeInHour: 1,
    showWriteMinutesDays: 1,
    draftMeetingReminderDays: 1,
    draftMeetingCleanupDays: 1,
  });
  const [savedConfig, setSavedConfig] = useState({});
  const [daysOption, setDaysOption] = useState([]);
  const hourOptions = generateOptions(24);
  const hourOptionNew = generateOptionNew(24);

  const [selectedDays, setSelectedDays] = useState(0);
  const [selectedHours, setSelectedHours] = useState(0);
  const location = useLocation();

  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  useEffect(() => {
    document.title = "Configuration: MinutesVault";
    const fetchConfig = async () => {
      try {
        if (!accessToken) {
          console.warn("Access token is missing");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/V1/configuration/viewConfiguration/${organizationId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
            },
          }
        );

        if (response?.data?.data?.isInValidUser) {
          toast.error(response?.data?.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(setInValidUser(true));
        } else {
          dispatch(setInValidUser(false));
          daysOption();
        }
        if (response.data && response.data.data) {

          setConfig(response.data.data);
          setSavedConfig(response.data.data);
          const totalHours = response.data.data.writeMinuteMaxTimeInHour;

          const days = Math.floor(totalHours / 24);
          const hours = totalHours % 24;
          setSelectedDays(days);
          setdraftMeetingReminderDays(response.data.data.draftMeetingReminderDays)
          setSelectedHours(hours);
        }
      } catch (error) {
        console.error("Error fetching config:", error);
        if (handleApiError(error)) return;
      }
    };
    if (!authData?.isInValidUser) {
      fetchConfig();
    }
    fetchConfig();
    const daysOption = async () => {
      try {
        if (!accessToken) {
          console.warn("Access token is missing");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/V1/configuration/getDaysOption`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
            },
          }
        );
        if (response?.data?.data?.isInValidUser) {
          toast.error(response?.data?.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(setInValidUser(true));
        } else {
          dispatch(setInValidUser(false));
        }
        setDaysOption(response.data.data);
      } catch (error) {
        console.error("Error fetching config:", error);
        if (handleApiError(error)) return;
      }
    };

    daysOption();
  }, [organizationId, accessToken]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericValue = parseInt(value, 10) || 0;
    // setConfig((prevConfig) => ({
    //   ...prevConfig,
    //   [name]: parseInt(value, 10),
    // }));
    setConfig((prevConfig) => {
      let updatedConfig = {
        ...prevConfig,
        [name]: numericValue,
      };

      // If reminder days change, update cleanup days automatically
      if (name === "draftMeetingReminderDays") {
        updatedConfig.draftMeetingCleanupDays = numericValue + DraftCleanupDays;
      }

      return updatedConfig;
    });

    if (name === "writeMinuteMaxTimeInHour") {
      setSelectedHours(value);
    }

    if (name === "showWriteMinutesDays") {
      setSelectedDays(value);
    }
    if (name === "draftMeetingCleanupDays") {
      setdraftMeetingCleanupDays(numericValue);
    }

    if (name === "draftMeetingReminderDays") {
      setdraftMeetingReminderDays(numericValue);
    }
  };

  const handleBlurValidation = (name, value) => {
    let error = "";
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };


 const handleSaveConfiguration = async () => {
    setIsLoading(true);

    // Ensure values are properly parsed
    const reminderDays = parseInt(config.draftMeetingReminderDays, 10) || 0;
    let cleanupDays = parseInt(config.draftMeetingCleanupDays, 10) || 0;
    const minCleanupDays = reminderDays + DraftCleanupDays;

    // Automatically update cleanup days before validation
    if (cleanupDays < minCleanupDays) {
      cleanupDays = minCleanupDays;
      setConfig((prevConfig) => ({
        ...prevConfig,
        draftMeetingCleanupDays: cleanupDays,
      }));
    }

    // Validate cleanup days
    if (cleanupDays < minCleanupDays) {
      toast.error(`Cleanup days must be at least ${minCleanupDays} days`, {
        position: "top-right",
        autoClose: 4000,
      });
      setIsLoading(false);
      return;
    }


    const totalWriteMinutesTime =
      parseInt(selectedDays) * 24 + parseInt(selectedHours);

    const configData = {
      organizationId,
      amendmentRequestTime: config.amendmentRequestTime,
      acceptanceRejectionEndtime: config.acceptanceRejectionEndtime,
      writeMinuteMaxTimeInHour: totalWriteMinutesTime,
      isAlert: false,
      draftMeetingReminderDays: reminderDays,
      draftMeetingCleanupDays: cleanupDays,
    };

    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/configuration/createConfiguration`,
        { ...configData, organizationId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        }
      );
      if (response?.data?.data?.isInValidUser) {
        toast.error(response?.data?.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        dispatch(setInValidUser(true));
      } else {
        dispatch(setInValidUser(false));
      }
      if (response.data.success) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setSavedConfig(configData);
      } else {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      if (handleApiError(error)) return;
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <div className="main-content">
        <div className="meeting-room-page">
          <div className="meeting-header-text line-height-h4 d-flex align-items-center justify-content-between">
            <h4>Configuration</h4>
            <BackButton show={camefromPreviousPage} />
          </div>
          <form className="details-form mt-2">
          
            <div className="pb-3 alert-box">
              <label className="checkbox-container mb-1 d-flex mb-0 me-2">
                Allow acceptance of meeting minutes within
              </label>
              <div className="d-flex resp-flex-column desktop-align-center">
                <div className="alert-send-time width120">
                  <p>
                    <select
                      name="acceptanceRejectionEndtime"
                      value={config.acceptanceRejectionEndtime}
                      onChange={handleChange}
                      onBlur={(e) =>
                        handleBlurValidation(e.target.name, e.target.value)
                      }
                      className="custom-width-input ms-2"
                    >
                      {hourOptionNew.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                    hour(s)
                  </p>
                </div>
                <p>of meeting MOM creation.</p>
              </div>

              {errors.acceptanceRejectionEndtime && (
                <p className="error mt-2">
                  {errors.acceptanceRejectionEndtime}
                </p>
              )}
            </div>

            <div className="pb-3 alert-box">
              <label className="checkbox-container mb-1 d-flex mb-0 me-2">
                Allow write minutes / Add new agenda / Generate new MOM of
                meeting within
              </label>
              <div className="d-flex resp-flex-column ">
                <div className="alert-send-time width120">
                  <p>
                    <select
                      name="showWriteMinutesDays"
                      value={selectedDays}
                      onChange={handleChange}
                      onBlur={(e) =>
                        handleBlurValidation(e.target.name, e.target.value)
                      }
                      className="custom-width-input ms-2 "
                    >
                      {daysOption?.map((option) => (
                        <option key={option.dayValue} value={option.dayValue}>
                          {option.dayText}
                        </option>
                      ))}
                    </select>
                    day(s)
                  </p>{" "}
                </div>{" "}
                <p className="resp-text-center d-flex align-items-center justify-content-center">and</p>
                <div className="alert-send-time width120">
                  <p>
                    <select
                      name="writeMinuteMaxTimeInHour"
                      value={selectedHours}
                      onChange={handleChange}
                      onBlur={(e) =>
                        handleBlurValidation(e.target.name, e.target.value)
                      }
                      className="custom-width-input ms-2"
                    >
                      {hourOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                    hour(s)
                  </p>
                </div>
                <p className="resp-text-center d-flex align-items-center">
                  of meeting MOM creation.
                </p>
              </div>

              {errors.showWriteMinutesDays && (
                <p className="error mt-2">{errors.showWriteMinutesDays}</p>
              )}
              {errors.writeMinuteMaxTimeInHour && (
                <p className="error mt-2">{errors.writeMinuteMaxTimeInHour}</p>
              )}
            </div>

 <div className="pb-3 alert-box">
              <label className="checkbox-container mb-1 d-flex mb-0 me-2">
                Draft meeting reminder will be sent after
              </label>
              <div className="d-flex resp-flex-column desktop-align-center">
                <div className="alert-send-time width120">
                  <p>
                    <select
                      name="draftMeetingReminderDays"
                      value={draftMeetingReminderDays}
                      onChange={handleChange}
                      onBlur={(e) =>
                        handleBlurValidation(e.target.name, e.target.value)
                      }
                      className="custom-width-input ms-2"
                    >
                      {daysOption?.map((option) => (
                      <option key={option.dayValue} value={option.dayValue}>
                        {option.dayText}
                      </option>
                    ))}
                    </select>
                    day(s)
                  </p>
                </div>
                
              </div>

                <span className="text-muted" style={{ fontSize: '14px' }}>
                {/* Draft meeting will be deleted after <strong>{config.draftMeetingReminderDays + DraftCleanupDays}</strong> days. */}
                Draft meeting will be deleted after <strong>{savedConfig.draftMeetingCleanupDays }</strong> days.
              </span>
            </div>


            <div className="mt-3">
              {isLoading ? (
                <SmallLoaderButton />
              ) : (
                <button
                  className="add-btn send-email Mom-btn"
                  type="button"
                  onClick={handleSaveConfiguration}
                  disabled={isLoading}
                >
                  <p>Save Configuration</p>
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Configuration;
